import { useEffect, useState } from 'react';

const DEADLINE = new Date('2027-05-13T00:00:00+05:30').getTime();

const getRemaining = () => {
  const diff = Math.max(0, DEADLINE - Date.now());
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
};

export const Countdown = ({ dark = true }) => {
  const [time, setTime] = useState(getRemaining());

  useEffect(() => {
    const id = setInterval(() => setTime(getRemaining()), 1000);
    return () => clearInterval(id);
  }, []);

  const units = [
    { label: 'Days', value: time.days },
    { label: 'Hrs', value: time.hours },
    { label: 'Min', value: time.minutes },
    { label: 'Sec', value: time.seconds },
  ];

  return (
    <div
      data-testid="compliance-countdown"
      className={`flex items-center gap-4 sm:gap-6 font-mono ${dark ? 'text-white' : 'text-navy'}`}
    >
      {units.map((u, i) => (
        <div key={u.label} className="flex items-center gap-4 sm:gap-6">
          <div className="flex flex-col items-center min-w-[3ch]">
            <span className="text-2xl sm:text-4xl font-semibold tabular-nums">{String(u.value).padStart(2, '0')}</span>
            <span className="text-[10px] sm:text-xs uppercase tracking-[0.2em] opacity-60 mt-1">{u.label}</span>
          </div>
          {i < units.length - 1 && <span className="opacity-30 text-xl">:</span>}
        </div>
      ))}
    </div>
  );
};
